export class FindAllProjects {
  public static readonly type = '[Organisation/Projects/List] FindAllProjects';
  constructor(public readonly organisationId: string | null = null) {}
}
